import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const quickViewPoiClickOnElement = (category: string) => {
    const payload = {
        element: "poi",
        category,
        ...getTrackedSiteData()
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const quickViewPoiClickOnElement = (category: string) => {
    const payload = {
        element: "poi",
        category,
        ...getTrackedSiteData()
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};
